export default __webpack_public_path__ + "static/media/home-active.3b619156.svg";